/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get } from 'lodash';

// Components
import RadioButtons from 'shared/ui/components/form-components/RadioButtons.vue';
import Toggler from 'shared/ui/components/form-components/Toggler.vue';
import ColorPicker from 'shared/ui/components/form-components/pickers/ColorPicker.vue';
import ImagePicker from 'shared/ui/components/form-components/pickers/ImagePicker.vue';
import LiveDisplayPlacementForm from 'ui/components/live-session/LiveDisplayPlacementForm.vue';

// Constants
import { BACKGROUND_TYPES } from 'libs/services/live-display';

const __vue_script__ = {

    name: 'LiveDisplayForm',

    components: {
        RadioButtons,
        Toggler,
        ColorPicker,
        ImagePicker,
        LiveDisplayPlacementForm
    },

    model: {
        prop: 'value',
        event: 'change'
    },

    props: {
        value: {
            type: Object,
            required: true
        },

        event: {
            type: Object,
            required: true
        },

        liveStream: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            imagePickerExtensions: ['png', 'jpg', 'jpeg'],
            backgroundTypes: [{
                label: this.$i18n.t('live_sessions.settings.live_display.color'),
                value: BACKGROUND_TYPES.COLOR
            }, {
                label: this.$i18n.t('live_sessions.settings.live_display.image'),
                value: BACKGROUND_TYPES.IMAGE
            }],
            bgImage: [],
        };
    },

    computed: {
        backgroundType: {
            get() { return this.value.background_type; },
            set(value) {
                this.$emit('change', { field: 'background_type', value });
                if (value === BACKGROUND_TYPES.COLOR) {
                    this.$emit('change', { field: 'image', value: null });
                    this.$emit('change', { field: 'image_url', value: null });
                }
            }
        },
        image: {
            get() { return this.value.image; },
            set(value) {
                this.$emit('change', { field: 'image', value });
                this.$emit('change', { field: 'image_url', value: get(value, '0.url') });
            }
        },
        color: {
            get() { return this.value.background_color; },
            set(value) { this.$emit('change', { field: 'background_color', value }); }
        },
        isHybridSession() {
            return this.$services.liveStream.isHybrid(this.liveStream);
        },
        isRtmps() {
            return this.$services.liveStream.isRtmps(this.liveStream);
        },
        showSlideToggle() {
            return this.isRtmps && this.event.show_rtmps_slides;
        }
    },

    watch: {
        bgImage(next) {
            this.image = next;
        }
    },

    methods: {
        onChange(data) {
            this.$emit('change', data);
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "live-display-section" },
    [
      _c(
        "div",
        { staticClass: "background-section" },
        [
          _c("h4", { staticClass: "headlines" }, [
            _vm._v(_vm._s(_vm.$t("live_sessions.settings.background.label"))),
          ]),
          _c(
            "validation-provider",
            { attrs: { slim: true } },
            [
              _c("radio-buttons", {
                staticClass: "md-xs",
                attrs: {
                  inline: "inline",
                  options: _vm.backgroundTypes,
                  name: "background-type",
                },
                model: {
                  value: _vm.backgroundType,
                  callback: function ($$v) {
                    _vm.backgroundType = $$v
                  },
                  expression: "backgroundType",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "live-display-background" },
            [
              _vm.backgroundType === "image"
                ? _c(
                    "validation-provider",
                    { attrs: { slim: true } },
                    [
                      _c("image-picker", {
                        attrs: {
                          name: "background-picker",
                          hint: _vm.$t(
                            "live_sessions.settings.live_display.background_image_hint"
                          ),
                          extensions: _vm.imagePickerExtensions,
                          ratio: 16 / 9,
                          height: 1080,
                          width: 1920,
                          size: Math.pow(1024, 2) * 5,
                        },
                        model: {
                          value: _vm.bgImage,
                          callback: function ($$v) {
                            _vm.bgImage = $$v
                          },
                          expression: "bgImage",
                        },
                      }),
                    ],
                    1
                  )
                : _c(
                    "validation-provider",
                    { attrs: { slim: true } },
                    [
                      _c("color-picker", {
                        attrs: { name: "background-color" },
                        model: {
                          value: _vm.color,
                          callback: function ($$v) {
                            _vm.color = $$v
                          },
                          expression: "color",
                        },
                      }),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.isHybridSession
        ? _c("live-display-placement-form", {
            attrs: {
              value: _vm.value,
              "show-slide-toggle": _vm.showSlideToggle,
            },
            on: { change: _vm.onChange },
          })
        : _vm._e(),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/live-session/LiveDisplayForm.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__